import { getApiCall } from '../utils/Api';

// eslint-disable-next-line import/prefer-default-export
export const getLedger = async (queryParams) => {
  const result = await getApiCall(`/ledger${queryParams}`);
  return result.data;
};
